import React from "react";
import { AppBar, Box, Toolbar, Typography } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";

export const Header = () => {
  const theme = createTheme({
    palette: {
      mode: "light",
      primary: {
        main: "#424b93",
      },
    },
  });
  return (
    <Box sx={{ flexGrow: 1 }}>
      <ThemeProvider theme={theme}>
        <AppBar position="static" color="primary">
          <Toolbar>
            <img src="./constellix_logo.svg" alt="Constellix Sonar Logo" />
          </Toolbar>
        </AppBar>
      </ThemeProvider>
    </Box>
  );
};

export default Header;
